module.exports = __webpack_public_path__ + "static/media/progress-page-icon.d1cc9a8e.svg";